import React, { useState, useContext, useEffect } from "react";
import { SearchContext } from "./SearchContext/SearchProvider";
import { AuthContext } from "./AuthProvider";
import { withRouter } from "react-router-dom";

export const FilterContext = React.createContext();

const FilterProvider = ({ children }) => {
  const context = useContext(SearchContext);
  const auth = useContext(AuthContext);
  const [popoverStatus, setPopoverStat] = useState({});
  const [advPopoverStatus, setAdvPopoverStat] = useState({});
  const [advancedSearchOn, setAdvancedSearchOn] = useState(false);

  const popovers = [
    {
      values: context.allTags,
      name: "Tags",
      key: "tags",
      filterType: "tags"
    },
    {
      name: "Genres",
      key: "genres",
      filterType: "genres",
      values: context.allGenres
    },
    {
      values: context.allInstruments,
      name: "Instruments",
      key: "instruments",
      filterType: "instruments"
    }
  ];

  useEffect(() => {
    setAdvancedSearchOn(auth.user.AdvancedSearch);
  }, [auth.user]);

  const handleSwitch = checked => {
    setAdvancedSearchOn(checked);
  };

  const onPopoverChange = (value, index, advanced) => {
    if (advanced) return setAdvPopoverStat({ [index]: value });
    setPopoverStat({ [index]: value });
  };

  const allCharacteristicsContext = [...context.allCharacteristics];
  const characteristics = context.allCharacteristics.slice(0, 5);
  const advancedCharacteristics = context.allCharacteristics
    .slice(5, 8)
    .map(item => ({ ...item, isAdvanced: true }));
  const allCharacteristics = [...characteristics, ...advancedCharacteristics];

  const advancedSearchFilters = [
    ...context.allCharacteristics.slice(8),
    {
      values: context.allKeys,
      name: "Keys",
      filterName: "Keys",
      filterType: "key",
      key: "keys"
    }
  ];

  return (
    <FilterContext.Provider
      value={{
        allCharacteristicsContext,
        allCharacteristics,
        advancedSearchFilters,
        onPopoverChange,
        handleSwitch,
        popovers,
        context,
        popoverStatus,
        advPopoverStatus,
        advancedSearchOn,
        setPopoverStat,
        setAdvPopoverStat,
        setAdvancedSearchOn
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};

export default withRouter(FilterProvider);

export const useFilter = () => useContext(FilterContext);
